import { createFileRoute } from "@tanstack/react-router"
import { LoadingScreen } from "@/ui"

export const Route = createFileRoute("/(user)/(tenant)/evaluations")({
  component: RouteComponent,
})

function RouteComponent() {
  return <LoadingScreen />
}
